/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlErrorCode } from './ControlErrorCode';
import {
    ControlErrorCodeFromJSON,
    ControlErrorCodeFromJSONTyped,
    ControlErrorCodeToJSON,
} from './ControlErrorCode';

/**
 * A class with an error code, a text message and a detail dictionary to either be exported
 * as a dictionary or converted to an HTTPException with a given status code.
 * 
 * The text message can be formatted with additional keyword arguments.
 * eg. text="User with email {email} already has an account", email="example@example.com" will result in
 * "User with email example@example.,comn already has an account"
 * The detail dictionary or BaseErrorDetailsModel can contain any additional information about the error.
 * 
 * :param error_code: An instance of the ErrorCode enum
 * :param text: A text message describing the error (sourced from error_messages.py)
 * :param detail: A dictionary or Pydantic model containing additional details about the error
 * :param kwargs: Additional keyword arguments to format the text message
 * 
 * If you want the detail model to show up in the OpenAPI schema, you must create a subclass of ErrorCodesAndDetails
 * like:
 * ```
 * class TestErrorDetails(BaseErrorDetailsModel):
 *     test_property: str
 *     yes: bool
 * 
 * 
 * class TestCustomHTTPError(ErrorCodesAndDetails[TestErrorDetails]): ...
 * 
 * raise TestCustomHTTPError(
 *     error_code=ErrorCode.EXISTING_ACCOUNT_MS365,
 *     text="User with email {email} already has an account",
 *     detail=TestErrorDetails(test_property="example", yes=True),
 * ).to_http_exception(status_code=400)
 * )
 * ```
 * then raise TestCustomError rather than ErrorCodesAndDetails
 * @export
 * @interface ControlErrorCodesAndDetails
 */
export interface ControlErrorCodesAndDetails {
    [key: string]: any | any;
    /**
     * 
     * @type {ControlErrorCode}
     * @memberof ControlErrorCodesAndDetails
     */
    error_code: ControlErrorCode;
    /**
     * 
     * @type {string}
     * @memberof ControlErrorCodesAndDetails
     */
    text: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ControlErrorCodesAndDetails
     */
    detail?: { [key: string]: any; };
}

/**
 * Check if a given object implements the ControlErrorCodesAndDetails interface.
 */
export function instanceOfControlErrorCodesAndDetails(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "error_code" in value;
    isInstance = isInstance && "text" in value;

    return isInstance;
}

export function ControlErrorCodesAndDetailsFromJSON(json: any): ControlErrorCodesAndDetails {
    return ControlErrorCodesAndDetailsFromJSONTyped(json, false);
}

export function ControlErrorCodesAndDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlErrorCodesAndDetails {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
            ...json,
        'error_code': ControlErrorCodeFromJSON(json['error_code']),
        'text': json['text'],
        'detail': !exists(json, 'detail') ? undefined : json['detail'],
    };
}

export function ControlErrorCodesAndDetailsToJSON(value?: ControlErrorCodesAndDetails | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
            ...value,
        'error_code': ControlErrorCodeToJSON(value.error_code),
        'text': value.text,
        'detail': value.detail,
    };
}

